/**
 * 宣伝材料旧URLリダイレクト処理
 * 旧URL: /pages/salon?=popup を新URL: /pages/popup にリダイレクト
 * 印刷済み宣伝材料のリンク互換性を保つため
 */

document.addEventListener('DOMContentLoaded', function() {
  // 現在のURL情報を取得
  const currentPath = window.location.pathname;
  const currentSearch = window.location.search;
  
  // 旧popup URL形式かどうかチェック
  if (currentPath.includes('/pages/salon') && currentSearch.includes('=popup')) {
    // 新しいpopupページURLを構築
    const newUrl = window.location.origin + '/pages/popup';
    
    // リダイレクト実行
    console.log('旧URLを検出、リダイレクト先:', newUrl);
    window.location.replace(newUrl);
  }
  
  // その他の可能な旧URL形式との互換性
  if (currentPath.includes('/pages/salon')) {
    // すべての可能なpopupパラメータ形式をチェック
    const urlParams = new URLSearchParams(currentSearch);
    
    // ?=popup, ?popup, ?popup=true などの形式をチェック
    if (currentSearch.includes('=popup') || 
        urlParams.has('popup') || 
        currentSearch.includes('popup')) {
      
      const newUrl = window.location.origin + '/pages/popup';
      console.log('popupパラメータを検出、リダイレクト先:', newUrl);
      window.location.replace(newUrl);
    }
  }
});

/**
 * ブラウザ履歴の処理
 * 戻るボタンで旧URLに戻ることを防ぐ
 */
window.addEventListener('popstate', function(event) {
  const currentPath = window.location.pathname;
  const currentSearch = window.location.search;
  
  if (currentPath.includes('/pages/salon') && 
      (currentSearch.includes('=popup') || currentSearch.includes('popup'))) {
    
    const newUrl = window.location.origin + '/pages/popup';
    window.location.replace(newUrl);
  }
});

/**
 * デバッグ情報追加（オプション）
 * 開発モードでリダイレクト情報を表示
 */
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
  console.log('旧URLリダイレクトスクリプト読み込み完了');
  console.log('現在のURL:', window.location.href);
} 